import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { addressToString, deserializeCV } from '@stacks/transactions';

import { DISPLAY_DIGITS_AFTER_ZERO } from '../../../../constants/base';
import useGetTokenMetadata from '../../../../hooks/use-getTokenMetadata';
import { DisplayMetadataInActivityType } from '../../../../types/assetsMetadata';
import { displayFullAmount, formatBalance } from '../../../../utils/balance-tools';
import { WalletWithIcons } from '../../../Wallet/WalletWithIcons/WalletWithIcons';
import { useTransactionNonStxTokenStyles } from '../../TransactionNonStxToken/useTransactionNonStxTokenStyles';
import { useTransactionDetailStyles } from '../../useTransactionDetailStyles';

type TransactionNonStxTokenTypes = {
  payload: any;
  displayInModal?: boolean;
};

export const TransactionNonStxTokenInline = ({ payload }: TransactionNonStxTokenTypes) => {
  const [tokenData, setTokenData] = useState<DisplayMetadataInActivityType>();
  const classes = useTransactionNonStxTokenStyles();
  const detailsClasses = useTransactionDetailStyles();

  const { fetchTokenMetadata } = useGetTokenMetadata();

  useEffect(() => {
    if (tokenData) return;
    const amount = deserializeCV(payload.functionArgs[0]);
    // @ts-ignore
    const receiverAddress = addressToString(deserializeCV(payload.functionArgs[2])?.address);

    fetchTokenMetadata(payload.contractAddress, payload.contractName).then((tokenAsset) => {
      if ('value' in amount && tokenAsset) {
        if (!tokenAsset.decimals) return;
        const amountToDisplay = formatBalance(
          Number(amount.value) / Math.pow(10, tokenAsset.decimals),
          DISPLAY_DIGITS_AFTER_ZERO
        );
        setTokenData({
          ...tokenAsset,
          amount: Number(
            (Number(amount.value) / Math.pow(10, tokenAsset.decimals)).toFixed(tokenAsset.decimals)
          ),
          amountToDisplay: +amountToDisplay,
          to: receiverAddress,
        });
      }
    });
  }, [payload.contractAddress, payload.contractName, tokenData]);

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <div className={detailsClasses.itemWrapper}>
        <p className={detailsClasses.itemTitle}>Type</p>
        <div className={detailsClasses.itemContent}>
          {tokenData ? (
            <div className={classes.title}>
              Transfer {displayFullAmount(tokenData?.amount, tokenData?.decimals)}
              {tokenData?.symbol || payload.contractName}
            </div>
          ) : (
            <div className={classes.title}>{`Transfer ${payload.contractName}`}</div>
          )}
        </div>
      </div>
      {tokenData?.to && (
        <div className={detailsClasses.itemWrapper}>
          <p className={detailsClasses.itemTitle}>Receiver address</p>
          <div className={detailsClasses.itemContent}>
            <WalletWithIcons address={tokenData?.to} />
          </div>
        </div>
      )}
    </Box>
  );
};
